import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import * as yup from "yup";

import api from "~/services/api";
import { handleBlock } from "~/scripts/handleBlock.js";

import { toast } from "react-toastify";
import { formatMoney, formatNum } from "~/scripts/index.js";

import { Container } from "./styles";

import { getAccountTypes, getBanks } from "~/scripts";

import { Form, Input, Select } from "@rocketseat/unform";
import {
  FaTimes,
  FaAngleRight,
  FaUserAlt,
  FaLandmark,
  FaInfo,
  FaPager,
  FaMoneyCheckAlt,
  FaUsers,
  FaCalendar,
  FaCommentDollar
} from "react-icons/fa";

export default function FormFuncionario({
  cgc,
  agentId,
  agent,
  setAgent,
  edit
}) {
  const profile = useSelector(state => state.user.profile);
  const filial = useSelector(state => state.filial);
  const [block, setBlock] = useState(false);
  const [funcionario, setFuncionario] = useState({
    agent_id: agentId,
    created_by: profile.id,
    cgc,
    new: true,
    vr: 0,
    vt: 0,
    dependents: 0
  });
  const account_types = getAccountTypes(agent.country)

  const banks = getBanks(agent.country)

  useEffect(() => {
    async function loadFuncionario() {
      try {
        const response = await api.get("employee/?agentId=" + agentId, {
          agentId
        });
        const { data } = response;
        setFuncionario({ ...data, new: false });
      } catch(err) {

      }
    }
    loadFuncionario();
    setBlock(false);
  }, [agentId, setBlock, block]);

  async function handleSubmit() {
    try {
      const response = funcionario.new
        ? await api.post("employee/", funcionario)
        : await api.put("employee/", funcionario);
      toast.success(`Dados de funcionario atualizado com sucesso!`, {
        className: "success"
      });
      setAgent({
        ...agent,
        type: agent.type + ",2",
        new: false,
        agent_id: response.data.id
      });
      return;
    } catch (err) {
      toast.error("Por favor, revise os dados!", { className: "error" });
    }
  }

  const agentSchema = yup.object().shape({
    full_name: yup.string().required("Nome obrigatório"),
    short_name: yup.string().required("Apelido obrigatório"),
    bank: yup.string().required("Banco obrigatório"),
    account_type: yup.string().required("Tipo de conta obrigatório"),
    agency: yup.string().required(agent.country === "BR" ? "Agência obrigatória" : "R.N. Obrigatório" ),
    account: yup.string().required(agent.country === "BR" ? "Conta obrigatória" : "Account Number Obrigatório" ),
    pay_day: yup.string().required("Dia para pagar obrigatório."),
    inss: yup.string().required("Selecione uma opção."),
    vr: yup.string().required("Inscrição municipal obrigatório"),
    vt: yup.string().required("Inscrição municipal obrigatório")
  });

  return (
    <Container>
      <h1>Dados de Funcionario</h1>
      <Form
        initialData={funcionario}
        onSubmit={handleSubmit}
        schema={agentSchema}
      >
        <div className="rowInputs">
          <label htmlFor="full_name">
            <div>
              <FaUserAlt size={20} />
              <br />
              Nome
            </div>
            <Input
              name="full_name"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setFuncionario({ ...funcionario, full_name: e.target.value })
              }
              // placeholder={agent.name}
              maxLength="60"
            />
          </label>
          <label htmlFor="short_name">
            <div>
              <FaUserAlt size={20} />
              <br />
              Apelido
            </div>
            <Input
              name="short_name"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setFuncionario({ ...funcionario, short_name: e.target.value })
              }
              maxLength="40"
            />
          </label>
        </div>
        <hr />

        <div className="rowInputs">
          {/* <label htmlFor="accounting_code">
            <div>
              <FaBalanceScale size={20} />
              <br />
              C.Contáb.
            </div>
            <Input
              name="accounting_code"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  accounting_code: e.target.value
                })
              }
              maxLength="18"
            />
          </label>
          <label htmlFor="tax_nature">
            <div>
              <FaCube size={20} />
              <br />
              Natureza
            </div>
            <Input
              name="tax_nature"
              readOnly={!edit ? "readonly" : ""}
              onChange={e =>
                setFuncionario({ ...funcionario, tax_nature: e.target.value })
              }
            />
          </label> */}
          <label htmlFor="bank">
            <div>
              <FaLandmark size={20} />
              <br />
              Banco
            </div>
            <Select
              options={banks}
              name="bank"
              value={funcionario.bank}
              disabled={!edit ? "disabled" : ""}
              onChange={e =>
                setFuncionario({ ...funcionario, bank: e.target.value })
              }
            />
          </label>
          <label htmlFor="account_type">
            <div>
              <FaInfo size={20} />
              <br />
              Tipo
            </div>
            <Select
              options={account_types}
              name="account_type"
              disabled={!edit ? "disabled" : ""}
              onChange={e =>
                setFuncionario({ ...funcionario, account_type: e.target.value })
              }
              value={funcionario.account_type}
            />
          </label>
        </div>
        <hr />

        <div className="rowInputs">
          <label htmlFor="agency">
            <div>
              <FaPager size={20} />
              <br />
              { agent.country === "BR" ? "Agencia" : "R.N" }
            </div>
            <Input
              name="agency"
              readOnly={!edit ? "readonly" : ""}
              placeholder=""
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  agency: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={funcionario.agency}
              maxLength="40"
            />
          </label>
          {agent.country === "BR" ?
          <label htmlFor="agency_code" className="mini_input">
            <Input
              name="agency_code"
              readOnly={!edit ? "readonly" : ""}
              maxLength="1"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  agency_code: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={funcionario.agency_code}
            />
          </label>
          : null }
          <label htmlFor="account">
            <div>
              <FaMoneyCheckAlt size={20} />
              <br />
              { agent.country === "BR" ? "Conta" : "Acc." }
            </div>
            <Input
              name="account"
              readOnly={!edit ? "readonly" : ""}
              placeholder=""
              maxLength="40"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  account: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={funcionario.account}
            />
          </label>
          { agent.country === "BR" ?
          <label htmlFor="account_code" className="mini_input">
            <Input
              name="account_code"
              readOnly={!edit ? "readonly" : ""}
              maxLength="1"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  account_code: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={funcionario.account_code}
            />
          </label>
          : null }
        </div>
        <hr />

        <div className="rowInputs">
          <label htmlFor="dependents">
            <div>
              <FaUsers size={20} />
              <br />
              Depend.
            </div>
            <Input
              name="dependents"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Nº de dependentes"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  dependents: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              value={funcionario.dependents}
              maxLength="2"
            />
          </label>
          <label htmlFor="pay_day">
            <div>
              <FaCalendar size={20} />
              <br />
              Pagto.
            </div>
            <Input
              name="pay_day"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Dia para pagamento"
              maxLength="2"
              value={funcionario.pay_day}
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  pay_day: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
            />
          </label>
          <label htmlFor="inss">
            <div>
              <FaInfo size={20} />
              <br />
              INSS
            </div>
            <Select
              options={[
                { id: 1, title: "Sim" },
                { id: 2, title: "Não" }
              ]}
              disabled={!edit ? "disabled" : ""}
              name="inss"
              onChange={e =>
                setFuncionario({ ...funcionario, inss: e.target.value })
              }
              value={funcionario.inss}
            />
          </label>
        </div>
        <hr />

        <div className="rowInputs">
          <label htmlFor="pis">
            <div>
              <FaPager size={20} />
              <br />
              PIS
            </div>
            <Input
              name="pis"
              readOnly={!edit ? "readonly" : ""}
              placeholder="Número do PIS"
              value={funcionario.pis}
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  pis: e.target.value.toString().replace(/[^\d]+/g, "")
                })
              }
              maxLength="11"
            />
          </label>
          <label htmlFor="vr">
            <div>
              <FaCommentDollar size={20} />
              <br />
              VR/dia
            </div>
            <Input
              name="vr"
              readOnly={!edit ? "readonly" : ""}
              maxLength="6"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  vr: formatNum(e.target.value)
                })
              }
              value={formatMoney(
                funcionario.vr.toFixed(2),
                filial.country.language
              )}
            />
          </label>
          <label htmlFor="vt">
            <div>
              <FaCommentDollar size={20} />
              <br />
              VT/dia
            </div>
            <Input
              name="vt"
              readOnly={!edit ? "readonly" : ""}
              maxLength="6"
              onChange={e =>
                setFuncionario({
                  ...funcionario,
                  vt: formatNum(e.target.value)
                })
              }
              value={formatMoney(
                funcionario.vt.toFixed(2),
                filial.country.language
              )}
            />
          </label>
        </div>
        <hr />

        <div
          className="rowInputs"
          style={{ "justify-content": "space-between" }}
        >
          {edit ? (
            <>
              <button
                type="button"
                onClick={() =>
                  handleBlock(
                    funcionario.id,
                    funcionario.canceled_at,
                    "funcionario",
                    "employee",
                    setBlock
                  )
                }
                class="btnFinish trash"
                id="btnBlock"
              >
                {funcionario.canceled_at ? (
                  <>
                    <FaAngleRight size={16} />
                    &nbsp; Desbloquear funcionário
                  </>
                ) : (
                  <>
                    <FaTimes size={16} />
                    &nbsp; Bloquear funcionário
                  </>
                )}
              </button>
              <button type="submit" class="btnFinish" id="btnFinish">
                <>
                  {funcionario.new ? "Gravar" : "Atualizar"}{" "}
                  <FaAngleRight size={20} />
                </>
              </button>
            </>
          ) : null}
        </div>
      </Form>
    </Container>
  );
}
